<template>
  <div class="badge-container">
    <span :class="['univers-badge', getUniversClass(univers)]">
      {{ displayUnivers }}
    </span>
  </div>
</template>

<script>
export default {
  name: "UniversCell",

  props: {
    univers: {
      type: String,
      required: true,
    },
  },
  computed: {
    /** Affiche "Homme" même si on reçoit "HOMME" ou "homme". */
    displayUnivers() {
      if (!this.univers) return "";
      const lower = this.univers.toLowerCase(); // homme
      return lower.charAt(0).toUpperCase() + lower.slice(1); // Homme
    },
  },

  methods: {
    getUniversClass(univers) {
      const classes = {
        homme: "univers-homme",
        garcon: "univers-homme",
        male: "univers-homme",
        femme: "univers-femme",
        woman: "univers-femme",
        women: "univers-femme",
        female: "univers-femme",
        fille: "univers-femme",
        unisexe: "univers-unisexe",
        mixte: "univers-mixte",
      };
      return classes[String(univers).toLowerCase()] || "";
    },
  },
};
</script>

<style scoped>
.badge-container {
  display: inline-block;
}

.univers-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  border: 1px solid;
}

.univers-homme, .univers-man {
  background-color: #f3F3ff;
  color: #4246DE;
  border-color: #4246DE;
}

.univers-femme , .univers-woman{
  background-color: #FDF3FF;
  color: #F73FDE;
  border-color: #F73FDE;
}

.univers-unisexe, .univers-mixte {
  background-color: #F3FFFD;
  color: #19847B;
  border-color: #19847B;
}
</style>
